module.exports = __webpack_public_path__ + "img/sort-arrow.711bebb4.svg";